import React, { useState, useEffect } from 'react';

export default function ConfirmBox({ show, title, message, onConfirm, onCancel }) {
  const [actionMessage, setActionMessage] = useState('');

  useEffect(() => {
    if (!show) setActionMessage(''); // reset message when dialog closes
  }, [show]);

  const handleCancel = () => {
    setActionMessage('Cancelled');
    onCancel && onCancel();
  };

  const handleConfirm = () => {
    setActionMessage('Confirmed');
    onConfirm && onConfirm();
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          {title&&<div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={handleCancel}></button>
          </div>}
          <div className="modal-body">
            {message?.includes('<') ? (
              <p dangerouslySetInnerHTML={{ __html: message }} />
            ) : (
                <p>{message || 'Are you sure?'}</p>
            )}
            {actionMessage && <div className="alert alert-info mt-2">{actionMessage}</div>}
          </div>
          <div className="modal-footer">
            <button className="btn small-btn-primary" onClick={handleCancel}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}